module.exports = __webpack_public_path__ + "img/Group 1277.3fbcc4b5.svg";